import { CUSTOM_CAMERA_VARIANT } from 'state/customCameraStore';

export interface CustomCameraSettingsType {
  azimuth: number | false;
  inclination: number;
  radius: number;
}

const CustomCameraSettings: Record<
  CUSTOM_CAMERA_VARIANT,
  CustomCameraSettingsType | undefined
> = {
  SPACE: {
    radius: -1000,
    inclination: Math.PI / 4,
    azimuth: false,
  },
  TILES: {
    radius: -80,
    inclination: Math.PI / 4,
    azimuth: false,
  },
  flood: {
    radius: -440,
    inclination: Math.PI / 6,
    azimuth: false,
  },
  storm: {
    radius: -180,
    inclination: Math.PI / 12,
    azimuth: false,
  },
  bushfire: {
    radius: -100,
    inclination: Math.PI / 7,
    azimuth: -100 * (Math.PI / 180),
  },
  cyclone: {
    radius: -440,
    inclination: Math.PI / 18,
    azimuth: false,
  },
  WEATHER: undefined,
};

export default CustomCameraSettings;
